module.exports = __webpack_public_path__ + "static/media/Tentang-Kami.25cdfc1b.png";